<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <label class="mb-0" style="font-weight: 500;">
      <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label --> 
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="ms-1 text-decoration-none" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <textarea class="field_submit input_date input_date_mark hasDatepicker"
              [formControlName]="fieldKey"
              rows="4"
              style="resize: vertical; width: 100%;">
    </textarea>
  </div>
</div>